function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import format from "date-fns/format";
import isSameDay from "date-fns/isSameDay";
import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Button from "react-bootstrap/Button";
import "./ManualPages.css";
import moment from "moment-timezone";
import Table from "react-bootstrap/Table";
import Loader from "./../Loader/Loader";
import { FilterContext, UserContext } from "../index";
import classNames from "classnames";
import { HiDownload, HiCalendar, HiOutlineArrowsExpand } from "react-icons/hi";
import Select from "react-select";
import { GET_TASK_TRACKER_QUERY, GET_TASK_TRACKER_EXPORT_QUERY, USER_LISTING_QUERY, PROJECTS_LISTING_FOR_FILTER_QUERY } from "./query";
import { useQuery, useLazyQuery } from "@apollo/client";
import "rc-time-picker/assets/index.css";
import { TaskDetailWorkTimeLineModal } from "./TaskDetailWorkTimeLine";
import { GET_PROJECT_AND_TASK_APP_DATA_QUERY, GET_PROJECT_AND_TASK_SCREENSHOTS_QUERY } from "./../AddTask/query";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { stringToArrayOutput } from "./../SideMenu/Header";
import { ProjectEnableSection } from "./../MyProjects/MyProjects";
import { EndTaskTimeModal } from "./../AddTask/AddTask";
import { MdAdjust, MdDateRange } from "react-icons/md";
var LIMIT = 10;
var offsets = 0;
var APP_LIMIT = 10;
var ManualPages = function ManualPages(props) {
  var _props$location;
  var history = props.history;
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    userIds = _React$useState2[0],
    setUserIds = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    projectIds = _React$useState4[0],
    setProjectIds = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    taskIds = _React$useState6[0],
    setTaskIds = _React$useState6[1];
  var _React$useState7 = React.useState(""),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    entryParameterCheck = _React$useState8[0],
    setEntryParameterCheck = _React$useState8[1];

  //loadmore
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isAllLoaded = _React$useState10[0],
    setIsAllLoaded = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isLoadingMore = _React$useState12[0],
    setIsLoadingMore = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isLoadMoreButton = _React$useState14[0],
    setIsLoadMoreButton = _React$useState14[1];
  var _React$useState15 = React.useState(0),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    offset = _React$useState16[0],
    setOffset = _React$useState16[1];
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationUserCount = _React$useContext.organisationUserCount,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    from = _React$useContext.from,
    organisationBilling = _React$useContext.organisationBilling,
    organisationStatus = _React$useContext.organisationStatus;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    exportButton = _React$useState18[0],
    setExportButton = _React$useState18[1];
  var _React$useState19 = React.useState(stringToArrayOutput("Free Plan Days", organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    last14Days = _React$useState20[0],
    setLast14Days = _React$useState20[1];
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  React.useEffect(function () {
    if (from == "web" && role == "Member" && organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.allowMemberToAccessTimesheet) {
      props === null || props === void 0 ? void 0 : props.history.push("/timesheet");
    }
    if (from == "web" && role == "Member" && organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.manualTimeFeature) {
      props === null || props === void 0 ? void 0 : props.history.push("/manual-time");
    }
    if (role === "Member" && !organisationSettings.projectManagementFeature) {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" && from == "web" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var _useQuery = useQuery(PROJECTS_LISTING_FOR_FILTER_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        from: props !== null && props !== void 0 && props.from ? "desktop" : null,
        role: role
      },
      skip: !organisationId || !teamId
    }),
    projectsListingForFilter = _useQuery.data,
    projectListingFilterError = _useQuery.error,
    projectListingFilterLoading = _useQuery.loading,
    projectFilterRefetch = _useQuery.refetch;

  // const {
  //   data: taskTrackerData,
  //   error: taskTrackerError,
  //   loading: taskTrackerLoading,
  //   fetchMore,
  //   refetch: taskRefetch,
  // } = useQuery(GET_TASK_TRACKER_QUERY, {
  //   variables: {
  //     organisationId,
  //     teamId,
  //     userId: props?.from ? [props?.userId] : userIds.length ? userIds : null,
  //     projectId: projectIds.length ? projectIds : null,
  //     taskId: taskIds.length ? taskIds : null,
  //     limit: LIMIT,
  //     offset: 0,
  //     freePlanStartDate: organisationBilling?.planName == "free" ? (last14Days ? last14Days[0] : null) : null,
  //     freePlanEndDate: organisationBilling?.planName == "free" ? (last14Days ? last14Days[1] : null) : null,
  //     role,
  //     entryStatus: entryParameterCheck,
  //   },
  //   skip: !teamId || !organisationId,
  //   fetchPolicy: "network-only",
  // });

  var taskTrackerVariables = React.useMemo(function () {
    var _last14Days$, _last14Days$2;
    return {
      organisationId: organisationId,
      teamId: teamId,
      userId: props !== null && props !== void 0 && props.from ? [props === null || props === void 0 ? void 0 : props.userId] : userIds.length ? userIds : null,
      projectId: projectIds.length ? projectIds : null,
      taskId: taskIds.length ? taskIds : null,
      limit: LIMIT,
      //offset: 0,
      freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) === "free" ? (_last14Days$ = last14Days === null || last14Days === void 0 ? void 0 : last14Days[0]) !== null && _last14Days$ !== void 0 ? _last14Days$ : null : null,
      freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) === "free" ? (_last14Days$2 = last14Days === null || last14Days === void 0 ? void 0 : last14Days[1]) !== null && _last14Days$2 !== void 0 ? _last14Days$2 : null : null,
      role: role,
      entryStatus: entryParameterCheck
    };
  }, [organisationId, teamId, props === null || props === void 0 ? void 0 : props.from, props === null || props === void 0 ? void 0 : props.userId, userIds, projectIds, taskIds, organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName, last14Days, role, entryParameterCheck]);

  //   const {
  //   data: taskTrackerData,
  //   error: taskTrackerError,
  //   loading: taskTrackerLoading,
  //   fetchMore,
  //   refetch: taskRefetch,
  // } = useQuery(GET_TASK_TRACKER_QUERY, {
  //   variables: taskTrackerVariables, // ✅ memoized
  //   offset: 0, // ✅ base page only
  //   skip: !teamId || !organisationId,
  //   fetchPolicy: "network-only", // ✅ IMPORTANT
  // });
  var _useQuery2 = useQuery(GET_TASK_TRACKER_QUERY, {
      variables: _objectSpread(_objectSpread({}, taskTrackerVariables), {}, {
        offset: 0 // ✅ base page only
      }),
      skip: !teamId || !organisationId,
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first"
    }),
    taskTrackerData = _useQuery2.data,
    taskTrackerError = _useQuery2.error,
    taskTrackerLoading = _useQuery2.loading,
    fetchMore = _useQuery2.fetchMore,
    taskRefetch = _useQuery2.refetch;
  var _useLazyQuery = useLazyQuery(GET_TASK_TRACKER_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  var csvData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _exportData$getTaskTr;
    var dataArray, dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dataArray = [];
          dataValues = exportData === null || exportData === void 0 ? void 0 : (_exportData$getTaskTr = exportData.getTaskTrackerDetailsExport) === null || _exportData$getTaskTr === void 0 ? void 0 : _exportData$getTaskTr.taskTrackerDatas;
          if (dataValues) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", []);
        case 4:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Employee Name",
            key: "user",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Date",
            key: "date",
            width: 10,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Project Name",
            key: "projectName",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Task Name",
            key: "taskName",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Task Description",
            key: "taskDescription",
            width: 25,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Worked Hours",
            key: "totalTime",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Worked Time",
            key: "workedTime",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Track Status",
            key: "trackStatus",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (d, index) {
            var startTime = d.startTime,
              endTime = d.endTime,
              totalTime = d.totalTime,
              taskDescription = d.taskDescription,
              taskId = d.taskId,
              projectId = d.projectId,
              taskName = d.taskName,
              projectName = d.projectName,
              user = d.user,
              taskDate = d.taskDate,
              trackStatus = d.trackStatus;
            var date = moment(taskDate).format("DD MMM YYYY");
            var workedTime = "".concat(moment(startTime).format("hh:mm A") + " - " + moment(endTime).format("hh:mm A"));
            ws.addRow({
              user: user.displayName,
              date: date,
              projectName: projectName,
              taskName: taskName,
              taskDescription: taskDescription ? taskDescription : "-",
              totalTime: endTime ? totalTime : moment.duration(new moment().diff(new moment(startTime))).humanize(),
              workedTime: workedTime,
              trackStatus: trackStatus === true ? "Tracked" : "Untracked"
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          ws.getCell("D1").font = {
            bold: true
          };
          ws.getCell("E1").font = {
            bold: true
          };
          ws.getCell("F1").font = {
            bold: true
          };
          ws.getCell("G1").font = {
            bold: true
          };
          ws.getCell("H1").font = {
            bold: true
          };
          _context.next = 18;
          return wb.xlsx.writeBuffer();
        case 18:
          buf = _context.sent;
          fileName = "workfolio-work-history.xlsx";
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [exportData]);
  React.useEffect(function () {
    csvData();
  }, [exportData]);

  // React.useEffect(() => {
  //   taskRefetch();
  // }, [userIds, projectIds, taskIds]);

  React.useEffect(function () {
    setOffset(0);
    setIsAllLoaded(false);
  }, [userIds, projectIds, taskIds, entryParameterCheck]);

  // React.useEffect(() => {
  //   taskRefetch?.();
  //   projectFilterRefetch?.();
  // }, [props?.location?.key, props?.currentWorkingStatus]);
  var isFirstRender = React.useRef(true);
  React.useEffect(function () {
    // ✅ skip first render and skip during load-more
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (isLoadingMore) return; // ⭐ prevents double call

    taskRefetch === null || taskRefetch === void 0 ? void 0 : taskRefetch();
    projectFilterRefetch === null || projectFilterRefetch === void 0 ? void 0 : projectFilterRefetch();
  }, [props === null || props === void 0 ? void 0 : (_props$location = props.location) === null || _props$location === void 0 ? void 0 : _props$location.key, props === null || props === void 0 ? void 0 : props.currentWorkingStatus]);
  if (projectListingFilterLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (!projectsListingForFilter) {
    return null;
  }
  var getExportData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setExportButton(true);
            getExport({
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: props !== null && props !== void 0 && props.from ? [props === null || props === void 0 ? void 0 : props.userId] : userIds.length ? userIds : null,
                projectId: projectIds.length ? projectIds : null,
                taskId: taskIds.length ? taskIds : null
              }
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getExportData() {
      return _ref2.apply(this, arguments);
    };
  }();

  // const handleLoadMore = () => {
  //   if (taskTrackerLoading) return;

  //   setIsLoadingMore(true);
  //   offsets = offsets + 1;

  //   fetchMore({
  //     variables: {
  //       offset: offsets * LIMIT,
  //     },

  //     updateQuery: (prev, { fetchMoreResult }) => {
  //       if (!fetchMoreResult) return prev;
  //       if (
  //         fetchMoreResult?.getTaskTrackerDetails?.taskTrackerDatas?.length === 0 &&
  //         fetchMoreResult.getTaskTrackerDetails?.taskTrackerDatas.length < LIMIT &&
  //         !isAllLoaded
  //       ) {
  //         setIsAllLoaded(true);
  //       }
  //       setIsLoadingMore(false);

  //       const NewFilterData = [];

  //       fetchMoreResult.getTaskTrackerDetails?.taskTrackerDatas.forEach((newTask) => {
  //         const found = prev.getTaskTrackerDetails.taskTrackerDatas.find(
  //           (item) => item.taskTimeId === newTask.taskTimeId
  //         );

  //         if (!found) {
  //           // If not found, add validation.
  //           NewFilterData.push(newTask);
  //         }
  //       });

  //       return {
  //         ...prev,
  //         getTaskTrackerDetails: {
  //           ...prev.getTaskTrackerDetails,
  //           taskTrackerDatas: [...prev.getTaskTrackerDetails.taskTrackerDatas, ...NewFilterData],
  //         },
  //       };
  //     },
  //   });
  // };

  var handleLoadMore = function handleLoadMore() {
    if (taskTrackerLoading || isLoadingMore || isAllLoaded) return;
    setIsLoadingMore(true);
    var nextOffset = offset + 1;
    setOffset(nextOffset);
    fetchMore({
      variables: _objectSpread(_objectSpread({}, taskTrackerVariables), {}, {
        offset: nextOffset * LIMIT
      }),
      // updateQuery: (prev, { fetchMoreResult }) => {
      //   setIsLoadingMore(false);
      //   if (!fetchMoreResult) return prev;

      //   const prevList =
      //     prev?.getTaskTrackerDetails?.taskTrackerDatas || [];

      //   const newList =
      //     fetchMoreResult?.getTaskTrackerDetails?.taskTrackerDatas || [];

      //   if (newList.length < LIMIT) {
      //     setIsAllLoaded(true);
      //   }

      //   return {
      //     ...prev,
      //     getTaskTrackerDetails: {
      //       ...prev.getTaskTrackerDetails,
      //       taskTrackerDatas: [...prevList, ...newList],
      //     },
      //   };
      // },
      updateQuery: function updateQuery(prev, _ref3) {
        var _prev$getTaskTrackerD, _fetchMoreResult$getT;
        var fetchMoreResult = _ref3.fetchMoreResult;
        setIsLoadingMore(false);
        if (!fetchMoreResult) return prev;
        var prevList = (prev === null || prev === void 0 ? void 0 : (_prev$getTaskTrackerD = prev.getTaskTrackerDetails) === null || _prev$getTaskTrackerD === void 0 ? void 0 : _prev$getTaskTrackerD.taskTrackerDatas) || [];
        var incomingList = (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getT = fetchMoreResult.getTaskTrackerDetails) === null || _fetchMoreResult$getT === void 0 ? void 0 : _fetchMoreResult$getT.taskTrackerDatas) || [];
        if (incomingList.length < LIMIT) {
          setIsAllLoaded(true);
        }

        // ✅ STRONG DEDUPE (key fix)
        var map = new Map();

        // keep existing
        prevList.forEach(function (item) {
          map.set(item.taskTimeId, item);
        });

        // add new (overwrite duplicates safely)
        incomingList.forEach(function (item) {
          map.set(item.taskTimeId, item);
        });
        var merged = Array.from(map.values());
        return _objectSpread(_objectSpread({}, prev), {}, {
          getTaskTrackerDetails: _objectSpread(_objectSpread({}, prev.getTaskTrackerDetails), {}, {
            taskTrackerDatas: merged
          })
        });
      }
    })["catch"](function () {
      setIsLoadingMore(false);
    });
  };
  return !organisationSettings.projectManagementFeature ? /*#__PURE__*/React.createElement(ProjectEnableSection, {
    user: user,
    organisationId: organisationId,
    organisationSettings: organisationSettings,
    filterId: null,
    role: role,
    pageName: "work-history",
    isTaskViewCheck: null,
    teamId: teamId,
    projectIds: projectIds,
    taskIds: taskIds,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    last14Days: last14Days,
    from: props === null || props === void 0 ? void 0 : props.from,
    propsUserId: props === null || props === void 0 ? void 0 : props.userId,
    userIds: userIds,
    userActive: null,
    projectActive: null,
    taskActive: null,
    startDate: null,
    endDate: null,
    projectId: null,
    userUrl: null
  }) : /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-card",
    style: props.from ? {
      margin: "0rem"
    } : null
  }, /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-project-card-root"
  }, /*#__PURE__*/React.createElement(TaskTrackerDetail, {
    organisationId: organisationId,
    teamId: teamId,
    organisationSettings: organisationSettings,
    role: role,
    users: user,
    taskTrackerData: taskTrackerData,
    taskTrackerLoading: taskTrackerLoading,
    taskTrackerError: taskTrackerError,
    setUserIds: setUserIds,
    setProjectIds: setProjectIds,
    setTaskIds: setTaskIds,
    handleLoadMore: handleLoadMore,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    setIsAllLoaded: setIsAllLoaded,
    from: from,
    projectIds: projectIds,
    taskIds: taskIds,
    history: history,
    userId: props === null || props === void 0 ? void 0 : props.userId,
    propsFrom: props === null || props === void 0 ? void 0 : props.from,
    projectsListingForFilter: projectsListingForFilter,
    organisationBilling: organisationBilling,
    exportButton: exportButton,
    setExportButton: setExportButton,
    getExportData: getExportData,
    user: user,
    userIds: userIds,
    entryParameterCheck: entryParameterCheck,
    setEntryParameterCheck: setEntryParameterCheck
  })));
};
var TaskTrackerDetail = function TaskTrackerDetail(props) {
  var _projectsListingForFi, _projectsListingForFi2, _userListData$getProj, _taskTrackerData$getT, _taskTrackerData$getT2, _taskTrackerData$getT3, _taskTrackerData$getT4;
  var organisationId = props.organisationId,
    teamId = props.teamId,
    organisationSettings = props.organisationSettings,
    role = props.role,
    users = props.users,
    taskTrackerData = props.taskTrackerData,
    taskTrackerLoading = props.taskTrackerLoading,
    taskTrackerError = props.taskTrackerError,
    setUserIds = props.setUserIds,
    setProjectIds = props.setProjectIds,
    setTaskIds = props.setTaskIds,
    handleLoadMore = props.handleLoadMore,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    setIsAllLoaded = props.setIsAllLoaded,
    from = props.from,
    projectIds = props.projectIds,
    taskIds = props.taskIds,
    filterTaskLoading = props.filterTaskLoading,
    activeTab = props.activeTab,
    history = props.history,
    projectsListingForFilter = props.projectsListingForFilter,
    userId = props.userId,
    propsFrom = props.propsFrom,
    organisationBilling = props.organisationBilling,
    exportButton = props.exportButton,
    setExportButton = props.setExportButton,
    getExportData = props.getExportData,
    user = props.user,
    userIds = props.userIds,
    entryParameterCheck = props.entryParameterCheck,
    setEntryParameterCheck = props.setEntryParameterCheck;
  var _React$useState21 = React.useState(null),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    userParameterCheck = _React$useState22[0],
    setUserParameterCheck = _React$useState22[1];
  var _React$useState23 = React.useState(null),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    projectParameterCheck = _React$useState24[0],
    setProjectParameterCheck = _React$useState24[1];
  var _React$useState25 = React.useState(null),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    taskParameterCheck = _React$useState26[0],
    setTaskParameterCheck = _React$useState26[1];
  var _React$useState27 = React.useState(null),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    entryCheck = _React$useState28[0],
    setEntryCheck = _React$useState28[1];
  var _React$useState29 = React.useState(null),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    showTaskWorkTimeLineModal = _React$useState30[0],
    setShowTaskWorkTimeLineModal = _React$useState30[1];
  var _React$useState31 = React.useState("task-details"),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    taskDetailsActiveTab = _React$useState32[0],
    setTaskDetailsActiveTab = _React$useState32[1];
  var _React$useState33 = React.useState(false),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    desktopLoader = _React$useState34[0],
    setdesktopLoader = _React$useState34[1];
  var projectList = [{
    label: "All Project",
    value: ""
  }];
  var taskList = [{
    label: "All Task",
    value: ""
  }];
  var userList = [{
    label: "All Member",
    value: ""
  }];
  var entryList = [{
    label: "All Work Sessions",
    value: ""
  }, {
    label: "Ongoing Sessions",
    value: "ongoing"
  }];
  projectsListingForFilter === null || projectsListingForFilter === void 0 ? void 0 : (_projectsListingForFi = projectsListingForFilter.projectsListingForFilter) === null || _projectsListingForFi === void 0 ? void 0 : _projectsListingForFi.projects.map(function (item) {
    var projectName = item.projectName,
      projectId = item.projectId;
    return projectList.push({
      label: projectName,
      value: projectId
    });
  });
  projectsListingForFilter === null || projectsListingForFilter === void 0 ? void 0 : (_projectsListingForFi2 = projectsListingForFilter.projectsListingForFilter) === null || _projectsListingForFi2 === void 0 ? void 0 : _projectsListingForFi2.projects.map(function (item) {
    var projectName = item.projectName,
      projectId = item.projectId,
      tasks = item.tasks;
    if (projectParameterCheck && (projectParameterCheck === null || projectParameterCheck === void 0 ? void 0 : projectParameterCheck.value) == projectId) {
      tasks === null || tasks === void 0 ? void 0 : tasks.map(function (data) {
        return taskList.push({
          label: data.taskName,
          value: data.taskId
        });
      });
    }
  });
  React.useEffect(function () {
    if (projectParameterCheck === null) {
      setProjectParameterCheck({
        label: "All Project",
        value: ""
      });
    }
    if (taskParameterCheck === null) {
      setTaskParameterCheck({
        label: "All Task",
        value: ""
      });
    }
    if (entryCheck === null) {
      setEntryCheck({
        label: "All Work Sessions",
        value: ""
      });
    }
  }, [userListData]);
  React.useEffect(function () {
    if (projectParameterCheck !== null) {
      var _projectsListingForFi3;
      var projectNameData = projectsListingForFilter === null || projectsListingForFilter === void 0 ? void 0 : (_projectsListingForFi3 = projectsListingForFilter.projectsListingForFilter) === null || _projectsListingForFi3 === void 0 ? void 0 : _projectsListingForFi3.projects.find(function (p) {
        return p.projectId === projectParameterCheck.value;
      });
      taskList.splice(0, taskList.length);
      if (projectParameterCheck.label === "All Project") {
        var _projectsListingForFi4;
        projectsListingForFilter === null || projectsListingForFilter === void 0 ? void 0 : (_projectsListingForFi4 = projectsListingForFilter.projectsListingForFilter) === null || _projectsListingForFi4 === void 0 ? void 0 : _projectsListingForFi4.projects.map(function (item) {
          var projectName = item.projectName,
            projectId = item.projectId,
            tasks = item.tasks;
          tasks === null || tasks === void 0 ? void 0 : tasks.map(function (data) {
            return taskList.push({
              label: data.taskName,
              value: data.taskId
            });
          });
        });
      } else {
        var _projectNameData$task;
        projectNameData === null || projectNameData === void 0 ? void 0 : (_projectNameData$task = projectNameData.tasks) === null || _projectNameData$task === void 0 ? void 0 : _projectNameData$task.map(function (data) {
          return taskList.push({
            label: data.taskName,
            value: data.taskId
          });
        });
      }
    }
  }, [projectParameterCheck, projectIds]);
  var _useQuery3 = useQuery(USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        role: role
      },
      skip: !teamId || !organisationId
    }),
    userListData = _useQuery3.data,
    userListError = _useQuery3.error,
    userListLoading = _useQuery3.loading;
  var _useLazyQuery3 = useLazyQuery(GET_PROJECT_AND_TASK_APP_DATA_QUERY),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getAppUsageDetails = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    appSummaryData = _useLazyQuery4$.data,
    appSummaryError = _useLazyQuery4$.error,
    appSummaryLoading = _useLazyQuery4$.loading,
    appSummaryFetchMore = _useLazyQuery4$.fetchMore;
  React.useEffect(function () {
    if (showTaskWorkTimeLineModal && showTaskWorkTimeLineModal.taskId) {
      getAppUsageDetails({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          startTime: showTaskWorkTimeLineModal.startTime,
          endTime: showTaskWorkTimeLineModal.endTime,
          userId: showTaskWorkTimeLineModal === null || showTaskWorkTimeLineModal === void 0 ? void 0 : showTaskWorkTimeLineModal.userId,
          taskDate: showTaskWorkTimeLineModal.taskDate,
          limit: APP_LIMIT,
          offset: 0
        },
        fetchPolicy: "network-only",
        skip: !teamId && !organisationId
      });
    }
  }, [showTaskWorkTimeLineModal]);
  var _useLazyQuery5 = useLazyQuery(GET_PROJECT_AND_TASK_SCREENSHOTS_QUERY),
    _useLazyQuery6 = _slicedToArray(_useLazyQuery5, 2),
    getScreenshotsDetails = _useLazyQuery6[0],
    _useLazyQuery6$ = _useLazyQuery6[1],
    screenshotsData = _useLazyQuery6$.data,
    screenshotsError = _useLazyQuery6$.error,
    screenshotsLoading = _useLazyQuery6$.loading,
    screenshotsFetchMore = _useLazyQuery6$.fetchMore;
  React.useEffect(function () {
    if (userParameterCheck === null) {
      setUserParameterCheck({
        label: "All Member",
        value: ""
      });
    }
  }, [userListData]);
  userListData === null || userListData === void 0 ? void 0 : (_userListData$getProj = userListData.getProjectUser) === null || _userListData$getProj === void 0 ? void 0 : _userListData$getProj.map(function (item) {
    var userId = item.userId,
      displayName = item.displayName;
    return userList.push({
      label: displayName,
      value: userId
    });
  });
  if ((taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT === void 0 ? void 0 : (_taskTrackerData$getT2 = _taskTrackerData$getT.taskTrackerDatas) === null || _taskTrackerData$getT2 === void 0 ? void 0 : _taskTrackerData$getT2.length) !== 0 && (taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT3 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT3 === void 0 ? void 0 : (_taskTrackerData$getT4 = _taskTrackerData$getT3.taskTrackerDatas) === null || _taskTrackerData$getT4 === void 0 ? void 0 : _taskTrackerData$getT4.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  var handleShowTaskWorkTimeLineDetails = function handleShowTaskWorkTimeLineDetails(list) {
    setShowTaskWorkTimeLineModal(list);
  };
  var handleCloseTaskWorkTimeLineDetails = function handleCloseTaskWorkTimeLineDetails() {
    setShowTaskWorkTimeLineModal(null);
  };
  var displayNameWithSearch = function displayNameWithSearch() {
    setUserIds(userParameterCheck.value);
    setProjectIds(projectParameterCheck.value);
    setTaskIds(taskParameterCheck.value);
    setIsAllLoaded(false);
    setEntryParameterCheck(entryCheck.value);
    offsets = 0;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-project-card-root-list-section-new"
  }, /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-project-card-root-list-section-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-header-tab"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-header-tab"
  }, /*#__PURE__*/React.createElement(TabHeaderView, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userList: userList,
    projectParameterCheck: projectParameterCheck,
    setProjectParameterCheck: setProjectParameterCheck,
    setTaskParameterCheck: setTaskParameterCheck,
    projectList: projectList,
    taskParameterCheck: taskParameterCheck,
    taskList: taskList,
    displayNameWithSearch: displayNameWithSearch,
    from: from,
    taskTrackerLoading: taskTrackerLoading,
    filterTaskLoading: filterTaskLoading,
    activeTab: activeTab,
    entryList: entryList,
    setEntryParameterCheck: setEntryParameterCheck,
    entryParameterCheck: entryParameterCheck,
    organisationSettings: organisationSettings,
    entryCheck: entryCheck,
    setEntryCheck: setEntryCheck
  }), /*#__PURE__*/React.createElement("div", null), taskTrackerLoading ? /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-project-card-root-list-section-body"
  }, /*#__PURE__*/React.createElement(Loader, null)) : taskTrackerError ? /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-project-card-root-list-section-body"
  }, " ", /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.")) : /*#__PURE__*/React.createElement(TimeLineList, {
    taskTrackerData: taskTrackerData,
    users: users,
    organisationId: organisationId,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    handleLoadMore: handleLoadMore,
    isLoadMoreButton: isLoadMoreButton,
    history: history,
    from: from,
    role: role,
    propsFrom: propsFrom,
    handleShowTaskDetails: handleShowTaskWorkTimeLineDetails,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationSettings: organisationSettings,
    desktopLoader: desktopLoader,
    teamId: teamId,
    user: user,
    projectIds: projectIds,
    taskIds: taskIds,
    userIds: userIds
  }))))), /*#__PURE__*/React.createElement(TaskDetailWorkTimeLineModal, {
    showTaskModal: showTaskWorkTimeLineModal,
    handleCloseTaskDetails: handleCloseTaskWorkTimeLineDetails,
    taskDetailsActiveTab: taskDetailsActiveTab,
    setTaskDetailsActiveTab: setTaskDetailsActiveTab,
    organisationId: organisationId,
    teamId: teamId,
    organisationSettings: organisationSettings,
    userId: userId,
    getAppUsageDetails: getAppUsageDetails,
    appSummaryData: appSummaryData,
    appSummaryError: appSummaryError,
    appSummaryLoading: appSummaryLoading,
    getScreenshotsDetails: getScreenshotsDetails,
    screenshotsData: screenshotsData,
    screenshotsError: screenshotsError,
    screenshotsLoading: screenshotsLoading,
    screenshotsFetchMore: screenshotsFetchMore,
    appSummaryFetchMore: appSummaryFetchMore
  }));
};
var TabHeaderView = function TabHeaderView(props) {
  var userParameterCheck = props.userParameterCheck,
    setUserParameterCheck = props.setUserParameterCheck,
    userList = props.userList,
    projectParameterCheck = props.projectParameterCheck,
    setProjectParameterCheck = props.setProjectParameterCheck,
    projectList = props.projectList,
    taskParameterCheck = props.taskParameterCheck,
    setTaskParameterCheck = props.setTaskParameterCheck,
    taskList = props.taskList,
    displayNameWithSearch = props.displayNameWithSearch,
    from = props.from,
    taskTrackerLoading = props.taskTrackerLoading,
    entryList = props.entryList,
    setEntryParameterCheck = props.setEntryParameterCheck,
    entryParameterCheck = props.entryParameterCheck,
    organisationSettings = props.organisationSettings,
    entryCheck = props.entryCheck,
    setEntryCheck = props.setEntryCheck;
  var _React$useState35 = React.useState(null),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    activeFilter = _React$useState36[0],
    setActiveFilter = _React$useState36[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "project-and-task-section-second-menu-filter"
  }, window.innerWidth <= 1024 && window.innerWidth <= 1380 ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-div-small-screen"
  }, from !== "desktop" ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      setUserParameterCheck(e);
      setActiveFilter(true);
    },
    options: userList,
    className: "task-tracker-filter-user-select",
    classNamePrefix: "Filter By User"
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: projectParameterCheck,
    onChange: function onChange(e) {
      setProjectParameterCheck(e);
      setTaskParameterCheck({
        label: "All Task",
        value: ""
      });
      setActiveFilter(true);
    },
    options: projectList,
    className: "task-tracker-filter-user-select",
    classNamePrefix: "Filter By Project "
  }))), /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-div-small-screen"
  }, projectParameterCheck.label !== "All Project" ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-user task-tracker-filter-div-small-screen-select"
  }, /*#__PURE__*/React.createElement(Select, {
    value: taskParameterCheck,
    onChange: function onChange(e) {
      setTaskParameterCheck(e);
      setActiveFilter(true);
    },
    options: taskList,
    className: "task-tracker-filter-user-select ",
    classNamePrefix: "Filter By Task "
  })) : null, /*#__PURE__*/React.createElement(Button, {
    className: "project-and-task-section-second-menu-filter-button task-tracker-filter-div-small-screen-button",
    variant: activeFilter ? "primary" : "outline-secondary",
    onClick: function onClick() {
      return displayNameWithSearch();
    },
    disabled: taskTrackerLoading
  }, "Apply Filter")))) : /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-div"
  }, /*#__PURE__*/React.createElement("div", null, from !== "desktop" ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      setUserParameterCheck(e);
      setActiveFilter(true);
    },
    options: userList,
    className: "task-tracker-filter-user-select",
    classNamePrefix: "Filter By User"
  })) : null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: projectParameterCheck,
    onChange: function onChange(e) {
      setProjectParameterCheck(e);
      setTaskParameterCheck({
        label: "All Task",
        value: ""
      });
      setActiveFilter(true);
    },
    options: projectList,
    className: "task-tracker-filter-user-select",
    classNamePrefix: "Filter By Project "
  }))), /*#__PURE__*/React.createElement("div", null, projectParameterCheck !== null && projectParameterCheck.label !== "All Project" ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: taskParameterCheck,
    onChange: function onChange(e) {
      setTaskParameterCheck(e);
      setActiveFilter(true);
    },
    options: taskList,
    className: "task-tracker-filter-user-select",
    classNamePrefix: "Filter By Task "
  })) : null), /*#__PURE__*/React.createElement("div", null, organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-filter-user task-tracker-filter-div-small-screen-select"
  }, /*#__PURE__*/React.createElement(Select, {
    value: entryCheck,
    onChange: function onChange(e) {
      // setEntryParameterCheck(e.value);
      setEntryCheck(e);
      setActiveFilter(true);
    },
    options: entryList,
    className: "task-tracker-filter-user-select ",
    classNamePrefix: "Filter By Task "
  })) : null)), /*#__PURE__*/React.createElement(Button, {
    className: "project-and-task-section-second-menu-filter-button",
    variant: activeFilter ? "primary" : "outline-secondary",
    onClick: function onClick() {
      return displayNameWithSearch();
    },
    disabled: taskTrackerLoading
  }, "Apply Filter")));
};
export var TimeLineList = function TimeLineList(props) {
  var _taskTrackerData$getT5, _taskTrackerData$getT6, _taskTrackerData$getT7, _taskTrackerData$getT10, _taskTrackerData$getT11;
  var taskTrackerData = props.taskTrackerData,
    users = props.users,
    organisationId = props.organisationId,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    handleLoadMore = props.handleLoadMore,
    isLoadMoreButton = props.isLoadMoreButton,
    history = props.history,
    from = props.from,
    role = props.role,
    handleShowTaskDetails = props.handleShowTaskDetails,
    planName = props.planName,
    organisationSettings = props.organisationSettings,
    desktopLoader = props.desktopLoader,
    teamId = props.teamId,
    user = props.user,
    projectIds = props.projectIds,
    taskIds = props.taskIds,
    userIds = props.userIds;
  var _React$useState37 = React.useState(null),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    showEndTimeModal = _React$useState38[0],
    setShowEndTimeModal = _React$useState38[1];
  var _React$useState39 = React.useState(stringToArrayOutput("Free Plan Days", organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    last14Days = _React$useState40[0],
    setLast14Days = _React$useState40[1];
  var handleEndTimeShow = function handleEndTimeShow(list) {
    setShowEndTimeModal(list);
  };
  var handleEndTimeClose = function handleEndTimeClose() {
    setShowEndTimeModal(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-project-card-root-list-section-body-worktimeline"
  }, taskTrackerData !== null && taskTrackerData !== void 0 && (_taskTrackerData$getT5 = taskTrackerData.getTaskTrackerDetails) !== null && _taskTrackerData$getT5 !== void 0 && (_taskTrackerData$getT6 = _taskTrackerData$getT5.taskTrackerDatas) !== null && _taskTrackerData$getT6 !== void 0 && _taskTrackerData$getT6.length ? /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "desktop-home-project-card-table"
  }, /*#__PURE__*/React.createElement("tbody", {
    className: "desktop-home-project-card-table-body"
  }, taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT7 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT7 === void 0 ? void 0 : _taskTrackerData$getT7.taskTrackerDatas.map(function (list, index) {
    var _taskTrackerData$getT8, _taskTrackerData$getT9;
    var startTime = list.startTime,
      endTime = list.endTime,
      totalTime = list.totalTime,
      taskDescription = list.taskDescription,
      taskId = list.taskId,
      projectId = list.projectId,
      taskName = list.taskName,
      projectName = list.projectName,
      user = list.user,
      taskDate = list.taskDate,
      trackStatus = list.trackStatus,
      taskTimeId = list.taskTimeId,
      source = list.source;
    return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 || !isSameDay(Number(taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT8 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT8 === void 0 ? void 0 : (_taskTrackerData$getT9 = _taskTrackerData$getT8.taskTrackerDatas[index - 1]) === null || _taskTrackerData$getT9 === void 0 ? void 0 : _taskTrackerData$getT9.taskDate), Number(list === null || list === void 0 ? void 0 : list.taskDate)) ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: "4",
      className: "task-tracker-date-td"
    }, /*#__PURE__*/React.createElement("div", {
      className: "manual-time-date-divider-label-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-tracker-list-date-divider-label"
    }, /*#__PURE__*/React.createElement("span", {
      className: "manual-time-date-divider-label-icon"
    }, /*#__PURE__*/React.createElement(HiCalendar, null)), /*#__PURE__*/React.createElement("span", null, isToday(Number(taskDate)) ? "Today" : isYesterday(Number(taskDate)) ? "Yesterday" : format(Number(taskDate), "d-LLL-yyyy")))))) : null, index === 0 ? /*#__PURE__*/React.createElement("tr", {
      className: "desktop-home-project-card-table-header"
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "left"
      }
    }, "Task details"), role != "Member" ? /*#__PURE__*/React.createElement("td", null, "Employee Name") : "", /*#__PURE__*/React.createElement("td", null, "Worked Hours"), /*#__PURE__*/React.createElement("td", null, "Worked Time")) : null, /*#__PURE__*/React.createElement("tr", {
      key: taskTimeId,
      className: classNames("desktop-home-project-card-table-data-details worktimelin-cursor", {
        "desktop-home-project-card-table-data-details-selected-color": endTime === null
      })
      // onClick={(e) =>
      //   handleShowTaskDetails({
      //     projectId,
      //     projectName,
      //     taskName,
      //     taskId,
      //     userId: user.userId,
      //     taskDate,
      //     startTime: moment(startTime).format("hh:mm A"),
      //     endTime: moment(endTime).format("hh:mm A"),
      //     taskDescription,
      //   })
      // }
    }, /*#__PURE__*/React.createElement("td", {
      className: "task-tracker-data-td-task-name task-tracker-data-td-task-name-timeline-new",
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          projectId: projectId,
          projectName: projectName,
          taskName: taskName,
          taskId: taskId,
          userId: user.userId,
          taskDate: taskDate,
          startTime: moment(startTime).format("hh:mm A"),
          endTime: moment(endTime).format("hh:mm A"),
          taskDescription: taskDescription
        });
      }
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, projectName, " : ", taskName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "desktop-home-project-card-table-list-task-name desktop-home-project-card-table-list-timeline-task-name"
    }, /*#__PURE__*/React.createElement("span", null, projectName, " : ", taskName))), /*#__PURE__*/React.createElement("div", {
      className: "desktop-home-project-card-task-tracker-table-description-priority-date-data"
    }, taskDescription ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskDescription)
    }, /*#__PURE__*/React.createElement("div", {
      className: "desktop-home-project-card-table-description "
    }, taskDescription))) : null, /*#__PURE__*/React.createElement("div", {
      className: "desktop-home-project-card-task-tracker-table-description-priority-root project-detail-cursor"
    }, /*#__PURE__*/React.createElement(HiOutlineArrowsExpand, {
      className: "desktop-home-project-card-task-tracker-table-description-glass-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "desktop-home-project-card-task-tracker-table-description-priority work-timeline-view-detail-color"
    }, "View details"), " "))), role != "Member" ? /*#__PURE__*/React.createElement("td", {
      className: "",
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          projectId: projectId,
          projectName: projectName,
          taskName: taskName,
          taskId: taskId,
          userId: user.userId,
          taskDate: taskDate,
          startTime: moment(startTime).format("hh:mm A"),
          endTime: moment(endTime).format("hh:mm A"),
          taskDescription: taskDescription
        });
      }
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-name",
        className: "project-tooltip-start"
      }, user.displayName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "desktop-home-project-card-table-display-name"
    }, user.displayName))) : "", /*#__PURE__*/React.createElement("td", {
      className: "",
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          projectId: projectId,
          projectName: projectName,
          taskName: taskName,
          taskId: taskId,
          userId: user.userId,
          taskDate: taskDate,
          startTime: moment(startTime).format("hh:mm A"),
          endTime: moment(endTime).format("hh:mm A"),
          taskDescription: taskDescription
        });
      }
    }, endTime ? totalTime : "-"), /*#__PURE__*/React.createElement("td", {
      className: "task-tracket-task-list-start-end-time",
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          projectId: projectId,
          projectName: projectName,
          taskName: taskName,
          taskId: taskId,
          userId: user.userId,
          taskDate: taskDate,
          startTime: moment(startTime).format("hh:mm A"),
          endTime: moment(endTime).format("hh:mm A"),
          taskDescription: taskDescription
        });
      }
    }, moment(startTime).format("hh:mm A"), " -", " ", endTime === null ? users.userId === user.userId ? /*#__PURE__*/React.createElement("span", null, "Ongoing") : /*#__PURE__*/React.createElement("span", {
      className: "desktop-home-project-card-table-ongoing-others"
    }, " Ongoing") : moment(endTime).format("hh:mm A")), /*#__PURE__*/React.createElement("td", null, endTime === null && organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.automaticTaskTimer && role != "Member" ? source === "desktop" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "This task can only be stopped from the desktop app.")
    }, /*#__PURE__*/React.createElement("span", {
      className: "d-inline-block"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      className: "project-task-time-mapping-table-task-list-stop-again-button",
      disabled: true,
      style: {
        pointerEvents: "none"
      }
    }, /*#__PURE__*/React.createElement(MdAdjust, {
      className: "project-task-time-mapping-table-task-list-start-again-icon"
    }), "Stop Task"))) : /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      className: "project-task-time-mapping-table-task-list-stop-again-button",
      disabled: desktopLoader,
      onClick: function onClick() {
        return handleEndTimeShow({
          endTime: endTime,
          organisationId: organisationId,
          teamId: teamId,
          projectId: projectId,
          taskId: taskId,
          taskTimeId: taskTimeId,
          startTime: startTime,
          taskDate: taskDate
        });
      }
    }, /*#__PURE__*/React.createElement(MdAdjust, {
      className: "project-task-time-mapping-table-task-list-start-again-icon"
    }), "Stop Task") : null)));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "no-data-risk-setting"
  }, "No task found."), taskTrackerData !== null && taskTrackerData !== void 0 && (_taskTrackerData$getT10 = taskTrackerData.getTaskTrackerDetails) !== null && _taskTrackerData$getT10 !== void 0 && (_taskTrackerData$getT11 = _taskTrackerData$getT10.taskTrackerDatas) !== null && _taskTrackerData$getT11 !== void 0 && _taskTrackerData$getT11.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : planName == "free" ? /*#__PURE__*/React.createElement("p", {
    className: "project-task-tracket-all-task-label"
  }, "On the free plan, you can access the last 14 days of data only. Upgrade to the Pro plan to get the historical data.", " ") : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button project-management-miled-color"
  }, "You have seen all the tasks")) : null), /*#__PURE__*/React.createElement(EndTaskTimeModal, {
    showEndTimeModal: showEndTimeModal,
    handleEndTimeClose: handleEndTimeClose,
    organisationSettings: organisationSettings,
    user: user,
    teamId: teamId,
    planName: planName,
    last14Days: last14Days,
    role: role,
    type: "work-history",
    limit: LIMIT,
    projectIds: projectIds,
    taskIds: taskIds,
    userIds: userIds
  }));
};
export default ManualPages;